import { useForm, FormProvider, Controller } from "react-hook-form";
import {
    Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid
} from "@mui/material";
import SelectCultura from "../../../../../../../components/SelectsSimpleApiQuery/SelectCultura";
import SelectPraga from "../../../../../../../components/SelectsSimpleApiQuery/SelectPraga";
import { ICultura } from "../../../../MICulturas/ListarCulturas/Listagem";
import { IPraga } from "../../../../MIPragas/ListarPragas/Listagem";
import { enqueueSnackbar } from "notistack";
import {useEffect} from "react";
import {useMutation, useQueryClient} from "react-query";
import axiosClient from "../../../../../../../lib/axios";

interface Row {
    cultura: ICultura | null;
    praga: IPraga | null;
}

interface PropsAdicionarRelacionamento {
    open: boolean;
    onClose: () => void;
    onSubmit: (value: Row) => void;
    value: number;
}

export default function DialogAdicionarRelacionamento({
                                                          open,
                                                            value,
                                                          onClose,
                                                      }: PropsAdicionarRelacionamento) {
    const methods = useForm<Row>({
        defaultValues: { cultura: null, praga: null },
    });
    const queryClient = useQueryClient();
    const { control, handleSubmit, reset } = methods;

    // Reset form when dialog opens
    useEffect(() => {
        if (open) reset({ cultura: null, praga: null });
    }, [open, reset]);

    const {mutate: editarAgrotoxico} = useMutation({
        mutationKey: "cadastrar-agrotoxico",
        mutationFn: (data: any) =>
            axiosClient.put(`/receituario-agronomico/agrotoxicos/editar-agrotoxico/${value}`, data),
        onError: () => {
            enqueueSnackbar("Erro ao adicionar agrotóxico!", {variant: "error"});
        },
        onSuccess: () => {
            queryClient.invalidateQueries(`detalhar-agrotoxico/${value}`);
            enqueueSnackbar("Agrotóxico adicionado com sucesso!", {
                variant: "success",
            });
        },
    });

    const handleFormSubmit = (data: Row) => {
        if (!data.cultura || !data.praga) {
            enqueueSnackbar("Preencha todos os campos obrigatórios.", { variant: "warning" });
            return;
        }
        const payload = {
            praga_id: data.praga.id,
            cultura_id: data.cultura.id,
            action: "adicionar"
        }

        editarAgrotoxico(payload)
        onClose();
    };

    return (
        <Dialog open={open} fullWidth maxWidth="sm">
            <DialogTitle>Adicionar Relacionamento</DialogTitle>
            <DialogContent>
                <FormProvider {...methods}>
                    <form id="adicionar-relacionamento-form" onSubmit={handleSubmit(handleFormSubmit)}>
                        <Grid container spacing={2} sx={{ mt: 1 }}>
                            <Grid size={{xs: 12, md: 6}}>
                                <Controller
                                    name="cultura"
                                    control={control}
                                    rules={{ required: "Campo obrigatório" }}
                                    render={({ field, fieldState: {invalid} }) => (
                                        <SelectCultura
                                            error={invalid}
                                            required
                                            unique_select={true}
                                            value={field.value}
                                            onChange={(value: ICultura | ICultura[] | null) => {
                                                field.onChange(Array.isArray(value) ? value[0] : value);
                                            }}
                                        />
                                    )}
                                />
                            </Grid>
                            <Grid size={{xs: 12, md: 6}}>
                                <Controller
                                    name="praga"
                                    control={control}
                                    rules={{ required: "Campo obrigatório" }}
                                    render={({ field, fieldState: { invalid } }) => (
                                        <SelectPraga
                                            required={true}
                                            unique_select={true}
                                            value={field.value}
                                            onChange={(value: IPraga | IPraga[] | null) => {
                                                field.onChange(Array.isArray(value) ? value[0] : value);
                                            }}
                                            error={invalid}
                                        />
                                    )}
                                />
                            </Grid>
                        </Grid>
                    </form>
                </FormProvider>
            </DialogContent>
            <DialogActions>
                <Button variant="outlined" onClick={onClose}>
                    Cancelar
                </Button>
                <Button
                    variant="contained"
                    type="submit"
                    form="adicionar-relacionamento-form"
                >
                    Salvar
                </Button>
            </DialogActions>
        </Dialog>
    );
}